import { render } from "./AdminAgencias.vue?vue&type=template&id=f518fdb0"
import script from "./AdminAgencias.vue?vue&type=script&lang=js"
export * from "./AdminAgencias.vue?vue&type=script&lang=js"

import "./AdminAgencias.vue?vue&type=style&index=0&id=f518fdb0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__